import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withHandlers } from 'recompose';
import { Field, propTypes as fieldArrayFieldsPropTypes } from 'redux-form';

import { Button } from 'components/core/Button';
import FormItem from './FormItem';
import FormGroup from './FormGroup';

export const enhance = withHandlers({
	addField:
		({ fields }) =>
		() =>
			fields.push({}),
	removeField:
		({ fields }) =>
		(index) =>
		() =>
			fields.remove(index),
});

export function ReduxFormFieldArray({
	addField,
	array,
	className,
	fields,
	heading,
	label,
	removeField,
}) {
	return (
		<div className={classnames('field-array', className)}>
			{Children.toArray(
				fields.map((field, index) => (
					<>
						{heading && (
							<p className="alternate-names-heading">{heading}</p>
						)}
						<div className="field-array-item">
							<FormGroup>
								{array.map((item) => (
									<FormItem key={item.name}>
										<Field
											name={`${field}.${item.name}`}
											id={`${item.name}-${index}`}
											label={item.label}
											placeholder={item.placeholder}
											component={item.component}
										/>
									</FormItem>
								))}
							</FormGroup>
							<Button
								onClick={removeField(index)}
								className="remove-field"
							>
								<span>Remove</span>
							</Button>
						</div>
					</>
				)),
			)}
			<Button
				link
				secondary
				className="add-field"
				onClick={addField}
			>
				{label}
			</Button>
		</div>
	);
}

ReduxFormFieldArray.propTypes = {
	addField: PropTypes.func.isRequired,
	array: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			placeholder: PropTypes.string,
			component: PropTypes.func.isRequired,
		}),
	),
	className: PropTypes.string,
	fields: PropTypes.oneOfType([
		PropTypes.shape(fieldArrayFieldsPropTypes),
		PropTypes.array,
	]),
	heading: PropTypes.string,
	label: PropTypes.string.isRequired,
	removeField: PropTypes.func.isRequired,
};

export default enhance(ReduxFormFieldArray);
